module.exports = function() {
  return new Worker("/" + "e0e54808ae4c34df22fa.worker.js");
};